import React, {Suspense} from "react"
import {Canvas, useFrame, useLoader} from "@react-three/fiber"
import {FontLoader} from "three/examples/jsm/loaders/FontLoader.js"
import {useGLTF, Float, Lightformer, Text, Html, ContactShadows, Environment, MeshTransmissionMaterial} from "@react-three/drei"
import {EffectComposer, N8AO, TiltShift2} from "@react-three/postprocessing"
import {Route} from "wouter"
import {easing} from "maath"

function App() {
	// Preload the GLTF model
	useGLTF.preload("/bunny.glb")

	return (
		<Suspense fallback={<div>Loading...</div>}>
			<Canvas eventSource={document.getElementById("root")} eventPrefix="client" shadows camera={{position: [0, 0, 20], fov: 50}}>
				<color attach="background" args={["#aca7c4"]} />
				<spotLight position={[20, 20, 10]} penumbra={1} castShadow angle={0.2} />
				<Status position={[0, 0, -12]} />
				<Float floatIntensity={8}>
					<Route path="/">
						<Bunny scale={0.02} />
					</Route>
				</Float>
				<ContactShadows scale={100} position={[0, -7.5, 0]} blur={1} far={100} opacity={0.65} />
				<Environment preset="warehouse">
					<Lightformer intensity={2} position={[10, 10, 0]} scale={[100, 500, 0]} onUpdate={(self) => self.lookAt(0, 0, 0)} />
				</Environment>
				<EffectComposer disableNormalPass>
					<N8AO aoRadius={1} intensity={2} />
					<TiltShift2 blur={0.2} />
				</EffectComposer>
				<Rig />
			</Canvas>
		</Suspense>
	)
}

function Rig() {
	useFrame((state, delta) => {
		easing.damp3(state.camera.position, [Math.sin(-state.pointer.x) * 5, state.pointer.y * 3.5, 15 + Math.cos(state.pointer.x) * 10], 0.2, delta)
		state.camera.lookAt(0, 0, 0)
	})
}

function Bunny(props) {
	const {nodes} = useGLTF("/bunny.glb")

	// Define positions for specific nodes
	const positions = {
		Sphere_2: [40, 15, 75],
		Sphere: [-40, 15, 75],
		Cube: [0, -15, 100]
	}

	// Filter to include Cube nodes as well as Sphere_1 and Sphere_2
	const filteredNodes = Object.values(nodes).filter((node) => node.name.startsWith("Cube") || node.name === "Sphere" || node.name === "Sphere_2" || node.name === "Cube")

	return (
		<group {...props}>
			{filteredNodes.map((filteredNode) => (
				<mesh
					key={filteredNode.uuid}
					position={positions[filteredNode.name] || [0, 0, 0]} // Use the defined position or default to [0, 0, 0]
					receiveShadow
					castShadow
					geometry={filteredNode.geometry}>
					<MeshTransmissionMaterial
						roughness={0.2}
						metalness={0.15}
						clearcoat={0.2}
						color={"#d3cef5"}
						clearcoatRoughness={0.8}
						backside
						backsideThickness={10}
						thickness={50}
					/>
				</mesh>
			))}
		</group>
	)
}
function Status(props) {
	const text = "Happy Easter!"
	const font = useLoader(FontLoader, "/PPMonument.json")

	return (
		<Text fontSize={6} letterSpacing={-0.025} font={font} color="#BDE8EF" {...props}>
			{text}
			<Html style={{color: "transparent", fontSize: "33.5em"}} transform>
				{text}
			</Html>
		</Text>
	)
}

export default App
